import React from 'react';
import { Form, Input, Select, Row, Col, Button } from 'antd';
import { PlusOutlined } from '@ant-design/icons';

const { Option } = Select;

const InvoiceModalHeader = ({
  isPurchase,
  editingInvoice,
  clientAccounts,
  repositories,
  onAddAccount,
}) => (
  <>
    <Row gutter={[4]} style={{ marginLeft: 0, marginRight: 0 }}>
      <Col xs={5}>
        <Form.Item
          name="ClientAccountId"
          label={isPurchase ? 'المورد' : 'الزبون'}
          rules={[
            {
              required: true,
              message: isPurchase ? 'يرجى اختيار المورد!' : 'يرجى اختيار الزبون!',
            },
          ]}
        >
          <Select
            placeholder="اختر حساب"
            showSearch
            disabled={!!editingInvoice}
            filterOption={(input, option) =>
              (option?.children ?? '').toString().toLowerCase().includes(input.toLowerCase())
            }
            notFoundContent={
              <Button
                type="link"
                icon={<PlusOutlined />}
                onMouseDown={(e) => e.preventDefault()}
                onClick={onAddAccount}
              >
                إضافة
              </Button>
            }
          >
            {clientAccounts.map(account => (
              <Option key={account.id} value={account.id}>
                {account.name}
              </Option>
            ))}
          </Select>
        </Form.Item>
      </Col>

      <Col xs={3}>
        <Form.Item name="Number" label="رقم">
          <Input />
        </Form.Item>
      </Col>

      {isPurchase && (
        <Col xs={5}>
          <Form.Item
            name="RepositoryId"
            label="المستودع"
            rules={[{ required: true, message: 'يرجى اختيار المستودع!' }]}
          >
            <Select disabled={!!editingInvoice}>
              {repositories.map(repo => (
                <Option key={repo.id} value={repo.id}>
                  {repo.name}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
      )}
    </Row>

    <Col xs={13}>
      <Form.Item name="Notes" label="ملاحظات">
        <Input.TextArea />
      </Form.Item>
    </Col>
  </>
);

export default InvoiceModalHeader;
